const AppContext = {};

export default AppContext;